import React, { createContext, useContext } from "react";
import classnames from "classnames";
import styles from "./Spring.module.scss";

type Props = {
  children: React.ReactNode;
  size?: "large" | "small";
  fullBleedMobile?: boolean;
  allowNested?: boolean;
};

type Context = boolean;

const SpringContext = createContext<Context>(false);

const Spring = ({
  children,
  size = "large",
  fullBleedMobile,
  allowNested = false
}: Props) => {
  const isNested = useContext(SpringContext);
  if (isNested && !allowNested) {
    throw new Error("Spring: You should not nest the spring component.");
  }
  return (
    <SpringContext.Provider value={true}>
      <div
        className={classnames("spring", styles["Spring"], {
          [styles[`Spring--${size}`]]: size !== "large",
          [styles["Spring--fullBleedMobile"]]: fullBleedMobile
        })}
      >
        {children}
      </div>
    </SpringContext.Provider>
  );
};

export default Spring;
